import React, { useState } from 'react'
import Layout from '../../../Shared/Layout/LayoutAdmin';
import classNames from "classnames";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Table from 'react-bootstrap/Table';
import AlertDismissible from '../../../Shared/Components/AlertDismissible';
import { useForm, usePage } from '@inertiajs/inertia-react';
import Breadcrumbs from '../../../Shared/Components/Breadcrumbs';

const UploadExcel = ({ importErrors = [] }) => {
    const { flash } = usePage().props
    const accept_types = '.xls,.xlsx,.csv';
    const [showErrors, setShowErrors] = useState(false);

    const { data, setData, post, processing, errors, progress, reset } = useForm({
        file: null,
    })

    function submit(e) {
        e.preventDefault()

        post(route('balances.excel.upload'), {
            preserveScroll: true,
        })
    }

    return (
        <>
            <Row>
                <div className="mb-7 mt-7">
                    <Breadcrumbs currentPath="/admin/quotes/balances/import" />
                </div>
                <Col>
                    <h2>Saldos Importación</h2>
                </Col>
                <Col className='text-end'>
                    <Button href="/templates/balances_template.xls" variant="primary" className='me-3' disabled={processing} type="submit">Descargar Template Excel</Button>
                </Col>
                {flash.success && (
                    <AlertDismissible message={flash.success} type="success" style={{ opacity: 1 }} />
                )}
                {flash.error && (
                    <AlertDismissible message={flash.error} type="danger" style={{ opacity: 1 }} />
                )}

                {/* Mostrar errores de importación si existen */}
                {importErrors && importErrors.length > 0 && (
                    <div className="mt-3 mb-4">
                        <div className="alert alert-warning">
                            <h5>Se encontraron problemas en {importErrors.length} registros</h5>
                            <p>
                                Algunos registros no pudieron ser importados debido a errores.
                                <Button
                                    variant="link"
                                    className="p-0 ms-2"
                                    onClick={() => setShowErrors(!showErrors)}
                                >
                                    {showErrors ? 'Ocultar detalles' : 'Ver detalles'}
                                </Button>
                            </p>

                            {showErrors && (
                                <div className="table-responsive mt-3">
                                    <Table striped bordered hover size="sm">
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>Póliza</th>
                                                <th>Error</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {importErrors.map((error, index) => (
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td>{error.policy}</td>
                                                    <td>{error.error}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </div>
                            )}
                        </div>
                    </div>
                )}

                <Form onSubmit={submit}>
                    <Row>
                        <Col>
                            <Form.Group className="mb-3">
                                <Form.Label>Archivo de Excel para Importar</Form.Label>
                                <Form.Control type="file" className={classNames({ 'is-invalid': (errors.file) ? true : false, })} onChange={e => setData('file', e.target.files[0])} aria-invalid={errors.file ? "true" : "false"} accept={accept_types} />
                                {errors.file && <div className="mt-2 text-danger">{errors.file}</div>}
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="mt-3">
                            {progress && (
                                <progress value={progress.percentage} max="100">
                                    {progress.percentage}%
                                </progress>
                            )}
                            <Button variant="primary" className='me-3' disabled={processing} type="submit">Importar Archivo</Button>
                            <Button onClick={() => window.history.back()} variant="secondary" type="normal">Regresar</Button>
                        </Col>
                    </Row>
                </Form>
            </Row>
        </>
    );
}

UploadExcel.layout = page => <Layout children={page} title="Importar Saldos desde Excel" />

export default UploadExcel
